import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import './index.css';
import './components/account-navigation.css';
import './pages/Business/business.css';
import './components/account-theme.css';
import {UserProvider} from './context/User';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {StatusProvider} from './context/Status';
import {deploymentVersion, installDeploymentRefresh} from './helpers/deploymentRefresh';

installDeploymentRefresh(deploymentVersion);

document.body.setAttribute('theme-mode', 'dark');
localStorage.setItem('theme-mode', 'dark');

const isResizeObserverLoopError = (message) => (
    typeof message === 'string' && (
        message.includes('ResizeObserver loop limit exceeded') ||
        message.includes('ResizeObserver loop completed with undelivered notifications')
    )
);

const removeResizeObserverOverlay = () => {
    window.setTimeout(() => {
        const overlayIds = [
            'webpack-dev-server-client-overlay',
            'webpack-dev-server-client-overlay-div',
            'webpack-dev-server-client-overlay-container'
        ];
        overlayIds.forEach((id) => {
            const element = document.getElementById(id);
            if (element) {
                element.remove();
            }
        });
    }, 0);
};

window.addEventListener('error', (event) => {
    if (isResizeObserverLoopError(event.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        removeResizeObserverOverlay();
    }
}, true);

window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || event.reason;
    if (isResizeObserverLoopError(message)) {
        event.preventDefault();
        removeResizeObserverOverlay();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <StatusProvider>
            <UserProvider>
                <BrowserRouter>
                    <App/>
                    <ToastContainer/>
                </BrowserRouter>
            </UserProvider>
        </StatusProvider>
    </React.StrictMode>
);
